import BookNowModalHeader from './BookNowModalHeader';

export default BookNowModalHeader;
